import {
  ComponentSingleStyleConfig,
  Icon,
  useStyleConfig,
} from "@chakra-ui/react";
import React, { ReactElement } from "react";
import { MdEdit } from "react-icons/md";

import { ComponentStyleProps } from "../../../../../lib/styles/props/component-style-props";
import { IconButtonBase } from "../../../../icon-button";

export type CMFormCommentEditButtonProps = {
  icon?: ReactElement;
  size?: "sm" | "md" | "lg";
  tipMessage?: string;
  ariaLabel?: string;

  onClick: () => void;
} & ComponentStyleProps;

export const CMFormCommentEditButton = ({
  icon = <Icon as={MdEdit} />,
  size = "md",
  tipMessage,
  ariaLabel = "Edit comment",

  onClick,

  sx,
  ...rest
}: CMFormCommentEditButtonProps) => {
  const styles = useStyleConfig("CMFormCommentEditButtonStyles", { size });

  return (
    <IconButtonBase
      icon={icon}
      size={size}
      tipMessage={tipMessage}
      ariaLabel={ariaLabel}
      onClick={onClick}
      sx={{ ...styles, ...sx }}
      {...rest}
    />
  );
};

export const CMFormCommentEditButtonStyles: ComponentSingleStyleConfig = {
  baseStyle: {},
};
